import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
import { routes } from '@/router/routes';
import { sessionHelper } from '@/utils';
// import store from '@/state/store';

Vue.use(VueRouter);

Vue.use(VueMeta, { keyName: 'page' });

const router = new VueRouter({
	routes,
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		return { x: 0, y: 0 };
	},
});

// fires at the very start of any navigation
router.beforeEach((to, from, next) => {
	const userToken = sessionHelper.getUserToken();
	const userType = sessionHelper.getUserType();
	// sessionHelper.clearAllClientStorage();

	if (userToken && !['api', 'app'].includes(userType)) {
		sessionHelper.clearAllClientStorage();
		return next('/login');
	}

	if (to.path === '/login' && userToken) {
		return next('/');
	}

	if (to.path === '/' && !userToken) {
		return next('/login');
	}

	next();
});

// fires globally near the end of the navigation process
router.beforeResolve(async (to, from, next) => {

	next();
});

export default router;
